<template>
  <b-dropdown
    size="sm"
    no-caret
    :disabled="isDisabled"
    @click="clicked"
    @hide="dropdownClicked = false"
    @toggle="dropdownClicked = !dropdownClicked"
    toggle-class="test-export-product-indicator"
    :variant="checkConfirmation ? 'warning' : selectedOption.variant || null"
  >
    <template v-slot:button-content>
      <span>
        {{ isProcessing ? selectedOption.label : title }}
      </span>
      <span :class="[dropdownClicked ? 'openingRotation' : 'closingRotation']">
        <i class="py-0 ml-1 fa fa-chevron-down chevron-icon"></i>
      </span>
    </template>
    <b-dropdown-item
      href="#"
      :key="index"
      class="b-d-item"
      v-for="(opt, index) in options"
      @click="changeSelection(opt)"
      >{{ opt.label }}</b-dropdown-item
    >
  </b-dropdown>
</template>

<script>
export default {
  name: 'ActionButton',
  props: {
    title: {
      type: String,
      default: 'Menu',
    },
    isProcessing: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
      default: false,
    },
    confirmationText: {
      type: String,
      default: '',
    },
    confirmationTimeout: {
      type: Number,
      default: 5000,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedOption: {},
      timeoutId: null,
      checkConfirmation: false,
      dropdown_clicked: false,
    }
  },
  methods: {
    changeSelection(opt) {
      this.selectedOption = opt
      this.checkConfirmation = false
      clearTimeout(this.timeoutId)
      this.clicked()
    },
    clicked() {
      if (!this.checkConfirmation && this.confirmationText.length > 0) {
        this.checkConfirmation = true
        let that = this
        clearTimeout(this.timeoutId)
        this.timeoutId = setTimeout(function () {
          that.checkConfirmation = false
        }, this.confirmationTimeout)
      } else {
        this.checkConfirmation = false
        clearTimeout(this.timeoutId)
        if (Object.prototype.toString.call(this.selectedOption.callback) === '[object Function]') {
          this.selectedOption.callback()
        }
      }
    },
  },
  computed: {
    dropdownClicked: {
      get() {
        return this.dropdown_clicked
      },
      set(newValue) {
        this.dropdown_clicked = newValue
      },
    },
  },
  watch: {
    options: {
      handler: function (newValue) {
        if (newValue.length > 0) this.selectedOption = newValue[0]
      },
      deep: true,
      immediate: true,
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/.b-d-item a {
  color: black !important;
}
/deep/.b-d-item a:hover {
  color: black !important;
}
/deep/.b-d-item a:active {
  background-color: #f8f9fa;
}
.openingRotation svg {
  transition: transform 0.5s;
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
}
.chevron-icon {
  font-size: 12px;
}

.closingRotation svg {
  transition: transform 0.5s;
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -ms-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transform: rotate(0deg);
}
</style>
